<div class="card" [ngSwitch]="selected.observed">
  <h5>{{selected.observed?'Select Business':'Business List'}}</h5>

  <p-table #dt1 [value]="businesses" dataKey="id" [rows]="20" [responsive]="true" [lazy]="true" [loading]="loading"
    [rowHover]="true" styleClass="p-datatable-gridlines" [paginator]="true"   [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total"
    (onLazyLoad)="filter($event)" [globalFilterFields]="[]" responsiveLayout="scroll" [rowHover]="true"
    [showCurrentPageReport]="true" currentPageReportTemplate="[{first} to {last} of {totalRecords} restaurants]">
    <ng-template pTemplate="caption">
      <div class="tw-flex tw-justify-between tw-gap-2">
        <span class="p-input-icon-left tw-grow">
          <i class="pi pi-search"></i>
          <input pInputText type="text" #filter (input)="dt1.filter($event.target.value,'query')" placeholder="Search by name or domain"
            class="tw-w-full" />
        </span>

        @if(!selected.observed){
        <button pButton label="Add" class="mr-2" icon="pi pi-plus" [routerLink]="['/business/add']"></button>
        <button pButton label="Import from JustEat (json)" class="p-button-outlined mr-2" icon="pi pi-plus"
          [routerLink]="['/business/import']"></button>
        }

      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 12rem">Title</th>
        <th style="min-width: 12rem">Name</th>
        <th style="min-width: 12rem">Domain</th>
        @if(!selected.observed) {<th style="min-width: 12rem">Britlink</th>}
        <th *ngIf="!selected.observed">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-business>
      <tr (click)="selected.observed && selected.next(business)">
        <td>
          <div class="tw-flex tw-gap-4 tw-items-end">
            @if(business.UI?.Logo){
            <div [style.background-image]="'url(\'' + business.UI?.Logo + '\')'"
              class="tw-w-16 tw-aspect-square tw-bg-cover"></div>
            }
            <strong>{{business.UI?.Title || business.Name}}</strong>
          </div>
        </td>
        <td>
          {{business.Name}}
          @if(business.TestMode)
          {<span class="tw-text-xs tw-px-2 tw-py-1 tw-rounded tw-bg-yellow-100 tw-text-yellow-600">Test Mode</span>}
          @if(business.IsMock)
          {<span class="tw-text-xs tw-px-2 tw-py-1 tw-rounded tw-bg-blue-100 tw-text-blue-600">Mock</span>}
        </td>
        <td>
          @for (domain of business.Domains; track $index) {
          <div>
            {{domain}}
            @if(business.IsPublished) {
            <a href="//{{domain}}{{domain.includes('localhost')? ':4351' : ''}}" target="_blank"
              class="tw-ml-2 tw-text-blue-500" title="Open Website">
              <i class="pi pi-fw pi-external-link"></i>
            </a>
            }
          </div>
          }
          @if(!business.Domains?.length){
          <span class="tw-text-gray-400">No domain</span>
          }
        </td>
        @if(!selected.observed) {
        <td>
          @if(!business._britlink){ Not available }
          @else if(business._britlink==true){<i class="pi pi-spin pi-spinner"></i>}
          @else {
          <div (click)="fetchHeartbeat(business)">
            @if(!passed(business._britlink.time, 10))
            {<i class="pi pi-check-circle text-success tw-cursor-pointer" title="Online"></i>}
            @else { <i class="pi pi-exclamation-triangle text-danger tw-cursor-pointer" title="Offline"></i>}
            @if(business._britlink.state?.platform === 'android') {
              <i class="pi pi-mobile tw-ml-1" title="BritLinkDroid"></i>
              <span class="tw-text-xs tw-px-1 tw-py-0.5 tw-ml-1 tw-rounded tw-bg-green-100 tw-text-green-700">Android {{business._britlink.state?.androidVersion}}</span>
            }
            {{business._britlink.time|date:'short'}} v.{{business._britlink.state?.version}}
          </div>
          }
        </td>
        }
        <td *ngIf="!selected.observed">
          <p-menu #actionMenu [model]="business._actions" [popup]="true" appendTo="body"></p-menu>
          <button pButton [id]="'action-menu-'+business.Id" type="button" (click)="actionMenu.toggle($event)"
            icon="pi pi-ellipsis-h"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No business found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="8">Loading businesses data. Please wait.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>
<p-dialog header="Copy menus to restaurant" [visible]="!!copyMenuTargetBusiness" (visibleChange)="!$event && !copyMenuInProgress && (copyMenuTargetBusiness=null)" [modal]="true" [closable]="!copyMenuInProgress" [closeOnEscape]="!copyMenuInProgress" [style]="{ width: '42rem' }" [draggable]="false" [resizable]="false">
  @if(copyMenuTargetBusiness){
  <div class="tw-space-y-4">
    <p>Target restaurant: <strong>{{copyMenuTargetBusiness.Name}}</strong></p>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <label for="copy-menu-source">Source restaurant</label>
      <p-autoComplete inputId="copy-menu-source" [(ngModel)]="copyMenuSourceBusiness" [suggestions]="copyMenuSourceSuggestions"
        (completeMethod)="searchCopyMenuSource($event)" field="Name" [dropdown]="true" [forceSelection]="true" [disabled]="copyMenuInProgress"
        [minLength]="0" appendTo="body" placeholder="Search by restaurant name" styleClass="tw-w-full" inputStyleClass="tw-w-full">
        <ng-template let-business pTemplate="item">
          <div class="tw-flex tw-flex-col">
            <strong>{{business.Name}}</strong>
            <small class="tw-text-gray-500">{{business.UI?.Title || business.Domains?.join(', ') || business.Id}}</small>
          </div>
        </ng-template>
      </p-autoComplete>
      <small class="tw-text-gray-500">Type any part of the restaurant name to search all restaurants, not just the current page.</small>
    </div>
    @if(copyMenuInProgress){
    <div class="tw-flex tw-items-center tw-gap-2 tw-text-gray-600">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Copying menus from {{copyMenuSourceBusiness?.Name}} to {{copyMenuTargetBusiness.Name}}…</span>
    </div>
    }
    <div class="tw-flex tw-justify-end tw-gap-2">
      <button pButton type="button" label="Cancel" class="p-button-text" [disabled]="copyMenuInProgress" (click)="copyMenuTargetBusiness=null"></button>
      <button pButton type="button" label="Copy menus" icon="pi pi-copy" [loading]="copyMenuInProgress" [disabled]="!copyMenuSourceBusiness?.Id || copyMenuInProgress" (click)="copyMenusToBusiness($event)"></button>
    </div>
  </div>
  }
  <p-confirmPopup key="copyMenuConfirmPopup" appendTo="body"></p-confirmPopup>
</p-dialog>
